import React from 'react';
import {
    Typography,
    Divider,
    Button,
    Card,
} from '@mui/material';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import ShareIcon from '@mui/icons-material/Share';
import CardMedia from '@mui/material/CardMedia';
import A8AdEFEnglish from '../../components/A8/A8AdEFEnglish';
import CATEGORY_IMAGE from '../../../static/biz-professional/payment-4399011_1280.jpeg';
import { useNavigate } from 'react-router-dom';
import GL_IMAGE from '../../../static/biz-professional/GalleryLambda-Slide-TopMessage.png';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';

interface ArticlePageProps {
    path: string;
}


const Article: React.FC<ArticlePageProps> = ({ path }) => {
    const handleCopyClick = () => {
        navigator.clipboard.writeText(path)
            .then(() => {
                console.log('Link copied to clipboard!');
            })
            .catch((err) => {
                console.error('Unable to copy link to clipboard', err);
            });
    };

    const navigate = useNavigate()
    const handleImageClick = (path: string) => {
        navigate(path);
        window.scrollTo(0, 0);
    };
    return (
        <div>
            <Box sx={{ mt: 7, mb: 12, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                <Card elevation={0} sx={{ maxWidth: 1000 }} style={{ margin: '0px', padding: '5px' }}>
                    <CardContent>
                        <Typography variant="h1" id="introduction" style={{ fontSize: '30px' }}>
                            第3回: 1スライド1メッセージのルール
                        </Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="body2" color="text.primary">
                            Published on 2024 Jan 16th <br />
                            5 min read  <br />
                            by Michelle
                        </Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="h5">
                            プレゼンテーションのマストスキル獲得への2ステップ目「1スライドの中の基本構成を固めよう」では4つの構成要素を学んでいただきました。
                            そして、その中の一つは、トップメッセージでした。つまり、そのスライドに記載してある様々な情報・ファクトを通じてリスナーに伝えるべきあなたなりのメッセージ、それが
                            トップメッセージでしたね。構成要素としてののトップメッセージを理解した上で、本記事では、改めてトップメッセージについて深掘りをしていきましょう。
                        </Typography>
                    </CardContent>
                    <CardContent>
                        <Button variant="text" size="small" endIcon={<ShareIcon />} style={{ color: 'black' }} onClick={handleCopyClick}>
                            Copy URL of this ariticle
                        </Button>
                    </CardContent>
                    <CardMedia
                        component="img"
                        height="500"
                        sx={{

                            objectFit: 'cover',
                            filter: 'grayscale(90%)',
                        }}
                        image={CATEGORY_IMAGE}
                        alt="image of the category"
                    />
                    <CardContent>
                        <Typography variant="body2" color="text.secondary">
                            1スライド1メッセージのルール
                        </Typography>
                    </CardContent>
                    <Divider style={{ margin: '20px 0' }} />
                    <CardContent>
                        <Typography variant="h4" style={{ fontSize: '30px', fontWeight: 'lighter' }}>Table of Contents</Typography>
                    </CardContent>
                    <ol>
                        <li><a href="#1">論点によってファクトの分析視点は異なる。</a></li>
                        <li><a href="#2">トップメッセージはファクトではなく読者のメッセージである。</a></li>
                        <li><a href="#3">最後に一言。</a></li>
                    </ol>
                    <Divider id="1" style={{ margin: '40px 0' }} />
                    <CardContent>
                        <Typography variant="h4" style={{ fontSize: '30px' }}>論点によってファクトの分析視点は異なる。</Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="h5">
                            戦略コンサルティングファームを中心としたプロフェッショナルファームの仕事は多岐に渡りますが、その重要な仕事の一つは、
                            ファクトからメッセージを引き出すことです。その意味を理解するために、実例を見ながら解説していきましょう。

                            <br />
                            <br />
                            <CardMedia
                                component="img"
                                sx={{

                                    objectFit: 'cover',
                                }}
                                image={GL_IMAGE}
                                alt="image of the category"
                            />

                            <br />

                            スライドのボディには、とあるSoftwareX領域の「市場規模」と「自社のシェア」のグラフが記載されていますね。「市場規模」としては、これといったトレンドはなさそうですね。
                            そして「自社のシェアは鰻登りです。」
                            さて、そのファクトに対して、読者には何を伝えるべきでしょうか。その答えは、プレゼンテーション答えるべき論点・イシューによって大きく変わる、ということは
                            別記事の「イシューを洗い出そう。そして、構造化しよう。」を読んだ人であれば、明らかでしょう。ここで大事なことは、「論点によってファクトの分析視点が異なる」ということです。

                            <br /><br />

                            改めて先ほどのグラフを見てみてください。仮にスライドの論点が、「SoftwareX市場に追加投資すべきか」であれば「市場規模全体は増減がありそうだが、自社のシェアは上がっているので、
                            一定の追加投資は魅力的」かもしれません。一方で、スライドの論点が「市場規模のトレンド」だとすると、メッセージは「これといったトレンドはないが、直近ではダウントレンドなので、注視が必要」かもしれません。

                            <br /><br />

                            「論点によってファクトの分析視点が異なる」ことをよく理解して頂けたのではないでしょうか。 <br /><br />
                            <CardContent>
                                <TipsAndUpdatesIcon /> ここで、戦略コンサルティングファームであるMcKinsey & Companyの公開資料のリンクを下記にご紹介します。例えば、P7ページにて、グラフに対するメッセージを出していますね。
                                <blockquote>
                                    <Typography variant="body2" color="text.secondary">
                                        出典:METI <a href="https://www.meti.go.jp/shingikai/enecho/shigen_nenryo/sekiyu_gas/pdf/001_04_00.pdf" target="_blank" rel="noopener noreferrer"> meti.go.jp </a> (p7) - McKinsey & Company
                                    </Typography>
                                </blockquote>
                            </CardContent>
                        </Typography>
                    </CardContent>

                    <Divider id="2" style={{ margin: '40px 0' }} />
                    <CardContent>
                        <Typography variant="h4" style={{ fontSize: '30px' }}>トップメッセージはファクトではなく読者のメッセージである。</Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="h5">
                            ファクトの見方をイシュー・論点によって変えるべきであることを理解した上で、改めてトップメッセージの目的を考えてみましょう。
                            上記が意味するところを、ケーススタディを通じて、深掘していきます。

                            <br />
                            <br />

                            <Card elevation={3}>
                                <CardContent>
                                    <Typography variant="h4" style={{ fontSize: '22px' }}>ケーススタディ - ファクトとメッセージ </Typography>
                                    <Typography paragraph style={{ fontSize: '20px' }}>
                                        <br />「A社を買収すべきか否か」という問いで始まったプロジェクトがあります。あなたは市場環境を調査する担当です。
                                        調査を進めるにあたって、昨年度から今年にかけてその市場規模が5%成長していたという事実を掴んだとします。そのグラフを書いた
                                        スライドがあったとして、そのスライドに書かれているメッセージはどのような内容にすべきでしょうか。
                                        （読み進める前に、せっかくなので1分ほど考えてみてください。）
                                    </Typography>
                                </CardContent>
                            </Card>
                            <br />
                            <br />

                            さっそくですが、ダメな解答例から見ていきましょう。
                            <br />
                            <br />
                            <Card elevation={3}>
                                <CardContent>
                                    <Typography variant="h4" style={{ fontSize: '22px' }}>解答例（ダメな例）</Typography>
                                    <Typography paragraph style={{ fontSize: '20px' }}>
                                        <br />トップメッセージとして下記を記載します。「対象市場は昨年度から今年にかけて5％成長している」
                                    </Typography>
                                </CardContent>
                            </Card>
                            <br />
                            <br />

                            さきほどのMcKinseyのスライドとその解説を読んだみなさんは何故それがダメなのかすでにおわかりですね。上記のダメな解答例では、
                            （仮に分析視点が正しかったとしても）単なるファクトの説明だけに止まっており、読者に対するメッセージが何もないのです。 <br />

                            <br />
                            <br />
                            <Card elevation={3}>
                                <CardContent>
                                    <Typography variant="h4" style={{ fontSize: '22px' }}>解答例（良い例）</Typography>
                                    <Typography paragraph style={{ fontSize: '20px' }}>
                                        <br />トップメッセージとして下記を記載します。「A社の対象市場は昨年度から今年にかけて5％と堅調に成長しており、市場自体も魅力的である。」
                                    </Typography>
                                </CardContent>
                            </Card>
                            <br />
                            <br />

                            上記の解答例のメッセージの妥当性があるかないか別として、上記のメッセージを作る際に意識したことは、読者へのメッセージです。改めてケーススタディを読み返してみてください。
                            A社を買収すべきか否かを問われているプロジェクトですので、究極的には市場環境で分析結果として示すべきは、その市場が魅力的なのか、あるいはその中でそのような勝ち筋があるのか、
                            のような投資判断に資するような分析です。だからこそ、市場が5％伸びているというファクトのみならず、それは何を意味しているのか、まで踏み込んだメッセージが必要なのです。<br /><br />

                            トップメッセージはファクトではなく読者のメッセージである。という意味を理解して頂けたのではないでしょうか。
                        </Typography>
                    </CardContent>

                    <Divider id="3" style={{ margin: '40px 0' }} />
                    <CardContent>
                        <Typography variant="h4" style={{ fontSize: '30px' }}>最後に一言</Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="h5">
                            メッセージのないスライドって意外と多いんです。グラフだけが書いたスライド、或いはテーブル（表）だけが書いたスライドって意外と見覚えがありませんか。<br /><br />

                            ファクトの解釈は人によって違いますし、そもそも見る視点が大きく違うかもしれません。「私はこのファクトを通してこのメッセージを伝えたいんです」- そんな強い思いで、
                            あなただけが引き出せるユニークなメッセージを出してみてください。<br /><br />

                            本記事を参考にし、「ファクトの説明にとどまらず、論点を意識した上で、読者に伝えるべきことを意識したメッセージ作り」をしていきましょう。
                        </Typography>
                    </CardContent>

                    <Divider style={{ margin: '20px 0' }} />
                    <CardContent>
                        <A8AdEFEnglish />
                    </CardContent>
                    <Button
                        variant="text"
                        size="small"
                        endIcon={<ShareIcon />}
                        style={{ color: 'black' }}
                        onClick={() => handleImageClick("/")}
                    >
                        他のプレゼンテーションスキルを学ぶ（記事一覧へ）
                    </Button>
                </Card>
            </Box>
        </div>
    );
};

export default Article;
